import { t } from 'ttag'

import { Modal } from '@h2/components/containers/modal'
import { Heading } from '@h2/components/typography/heading'

import { LessonTable } from './lessonTable'

const AssignmentDetail = ({ openModal, setOpenModal, data }) => {
  return (
    <Modal
      isOpen={openModal}
      closeOnClickOverlay={true}
      onClose={() => setOpenModal(false)}>
      <Modal.Header>
        <Heading level="3">{t`Lessons Assigned`}</Heading>
      </Modal.Header>
      <Modal.Body>
        <LessonTable data={data} />
      </Modal.Body>
    </Modal>
  )
}

export { AssignmentDetail }
